var a=a=>"range"in a?null!=a?.range:null!=a?.value;export{a as hasItemValue};
//# sourceMappingURL=hasItemValue.js.map